<div id="cpfs_header" class="padding16">
    <div id="cpfs_h_text">{{trans('systems.labels.searchResults')}}</div>
    <div id="cpfs_h_find" [inlineSVG]="'assets/images/find.svg'" (click)="openFind()"></div>
    <div id="cpfs_h_x" [inlineSVG]="'assets/images/close.svg'" (click)="close()"></div>
</div>
<div class="white_round" id="cpfs_systems">
    <app-cp-system-list-item *ngFor="let iSystem of systems.filteredSystems; let i = index" [systemItem]='iSystem' [showInstaller]='true' [showBorder]="systems.filteredSystems.length-1 !== i" [showDelete]="true"></app-cp-system-list-item>
</div>